module.exports = __webpack_public_path__ + "static/media/comefunziona3.edb0753b.png";